import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types";
import classNames from "classnames";
import TabMenuWrapper from "../../elements/tab-menu-wrapper";
import TabMenu from "../../react-components/tab-menu";
import { generateReactKey } from "../../utils/reactKey";
import { setDynamicBreadcrumbList } from "../../redux/actions/actions";
import { connect } from "react-redux";
import "./style.scss";

const TabMenuAnyContent = props => {
  const { rendering, fields, match, setDynamicBreadcrumbList } = props;
  const [route, setRoute] = useState(match.params.param_1 || null);
  const { selectedTabIndex, tabs, componentPadding = { top: "default", bottom: "tiny" } } = fields,
    tabPath = route || tabs[0]?.fields.path.value,
    activeTabIndex = route ? tabs.findIndex(item => item.fields.path.value === tabPath) : selectedTabIndex.value || 0;
  match.params.tabPrefixPath = "t";

  const classNamesTabContent = classNames("tab-menu-any-content", "grid", "padding-top-" + componentPadding.top, "padding-bottom-" + componentPadding.bottom);

  useEffect(() => {
    if (route) {
      let breadCrumbNode = {
        breadcrumbName: tabs[activeTabIndex]?.fields?.label?.value
      };
      setDynamicBreadcrumbList([breadCrumbNode]);
      //window.history.pushState(null, null, `/${match.params.lang}/${match.params.sitecoreRoute}/t/${route}`);
    }
    return function cleanup() {
      setDynamicBreadcrumbList(null);
    };
  }, [route]);

  const tabSelected = (evt, tab, option) => {
    let breadCrumbNode = {
      breadcrumbName: tab?.label
    };
    setDynamicBreadcrumbList([breadCrumbNode]);
    setRoute(tab.path);
  };

  return (
    <div className={classNamesTabContent} datasourceid={rendering?.dataSource}>
      <TabMenu
        {...{
          match: match,
          tabMenu: {
            items: tabs.map(item => ({
              label: item.fields.label.value,
              path: item.fields.path.value
            }))
          },
          onTabClicked: (evt, tab, option) => tabSelected(evt, tab, option)
        }}
        selectedTabIndex={activeTabIndex}
      />
      {tabs[activeTabIndex] && (
        <div className="content-container">
          {tabs[activeTabIndex].fields.components &&
            tabs[activeTabIndex].fields.components.map(item => {
              return <TabMenuWrapper key={generateReactKey()}>{item}</TabMenuWrapper>;
            })}
        </div>
      )}
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  setDynamicBreadcrumbList: breadcrumbList => dispatch(setDynamicBreadcrumbList(breadcrumbList)),
  dispatch
});

export default withRouter(connect(null, mapDispatchToProps)(TabMenuAnyContent));

TabMenuAnyContent.propTypes = {
  tabMenu: PropTypes.object,
  children: PropTypes.arrayOf(PropTypes.object),
  componentPadding: PropTypes.shape({
    top: PropTypes.string,
    bottom: PropTypes.string
  })
};

TabMenuAnyContent.defaultPropTypes = {
  componentPadding: { top: "default", bottom: "tiny" }
};
